module.exports = __webpack_public_path__ + "static/media/ic-bar-burger.a2b24fca.svg";